import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Motion";

const SECTIONS = [
  {
    title: "1. Acceptance",
    body: "By accessing www.nexreq.ae you agree to these Terms of Use. If you do not agree, please do not use this website.",
  },
  {
    title: "2. Nature of This Website",
    body: "This website presents the recruitment, executive search, RPO and talent advisory services of NEXREQ UAE & GCC and allows employers and candidates to make enquiries and submissions. Content on this website is provided for general information and does not constitute an offer of employment, a guarantee of placement, or professional advice.",
  },
  {
    title: "3. Job Listings",
    body: "Some listings on this website may be marked as demonstration listings; these illustrate the format of mandates and do not represent live vacancies. Genuine mandates are managed directly by NEXREQ consultants. Submission of an application does not guarantee an interview, representation or placement.",
  },
  {
    title: "4. Acceptable Use",
    body: "You agree not to: submit false, misleading or third-party personal information without authority; attempt to gain unauthorized access to administrative areas; scrape or harvest data from this website; or interfere with its operation.",
  },
  {
    title: "5. Intellectual Property",
    body: "The NEXREQ name, brand identity, design and website content are the property of NEXREQ and may not be reproduced without written permission.",
  },
  {
    title: "6. Limitation of Liability",
    body: "This website is provided on an as-available basis. To the extent permitted by law, NEXREQ is not liable for indirect or consequential loss arising from use of this website. Nothing in these terms excludes liability that cannot be excluded by law.",
  },
  {
    title: "7. Governing Law",
    body: "These terms are governed by the laws applicable in the Emirate of Dubai, United Arab Emirates, without prejudice to mandatory rights in your jurisdiction of residence.",
  },
  {
    title: "8. Contact",
    body: "NEXREQ UAE & GCC — Bin Dasmal Building – 1, Al Quoz Industrial First, Dubai, United Arab Emirates — info@nexreq.ae. Last updated: September 2026.",
  },
];

const Terms = () => (
  <>
    <Seo
      title="Terms of Use — NEXREQ UAE & GCC"
      siteName="NEXREQ"
      description="Terms governing the use of the NEXREQ UAE & GCC website."
    />
    <PageHero
      eyebrow="Legal"
      lines={["Terms of Use."]}
      description="The terms governing use of the NEXREQ website and its enquiry, application and submission services."
    />
    <section className="bg-obsidian pb-28" data-testid="terms-content">
      <div className="nx-container max-w-3xl">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <div className="mt-12 first:mt-0">
              <h2 className="font-heading text-xl font-light text-white">{s.title}</h2>
              <p className="mt-4 text-sm leading-relaxed text-white/55">{s.body}</p>
            </div>
          </Reveal>
        ))}
        <p className="mt-14 border-t border-white/10 pt-8 text-sm text-white/40">
          Also see our{" "}
          <Link to="/privacy" className="text-emerald-400 hover:underline" data-testid="terms-privacy-link">
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </section>
  </>
);

export default Terms;
